import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import useStateCallback from "../../util/customHooks/useStateCallback";
import RegisterShiftTemplateModal from "./RegisterShiftTemplateModal";
import ajaxShiftTemplate from "../../util/remote/ajaxShiftTemplate";
import UpdateShiftTemplateModal from "./UpdateShiftTemplateModal";

const ViewShiftTemplates = () => {
  const { userId } = useContext(AuthContext);
  var station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));

  const [loading, setLoading] = useState(false);
  const [shifts, setShifts] = useState([]);
  const [viewType, setViewType] = useState("table view");

  const [station_id, setStationID] = useState(station_idd);

  // Fetch shift templates
  const fetchShiftTemplates = async () => {
    setLoading(true);
    const data = { station_id: station_id };

    const response = await ajaxShiftTemplate.list_shit_templates(data);

    if (response.status === "OK") {
      setShifts(response.details || []);
    } else {
      toast.error(response.message);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchShiftTemplates();
  }, [station_id]);

  const toggleView = (type) => setViewType(type);

  // Modal Actions (Register)
  const [register, setRegister] = useStateCallback(false);
  const handleRegister = () => {
    setRegister(false, () =>
      setRegister(
        <RegisterShiftTemplateModal
          func={fetchShiftTemplates}
          key={Date.now()} // forces fresh modal
        />
      )
    );
  };

  // Modal Actions (Update)
  const [Update, setUpdate] = useStateCallback(false);
  const handleUpdate = (shift) => {
    setUpdate(false, () =>
      setUpdate(
        <UpdateShiftTemplateModal data={shift} func={fetchShiftTemplates} />
      )
    );
  };

  // Filter buttons
  const filteredActions = [
    {
      label: "card view",
      icon: "fa-regular fa-address-card",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("card view"),
    },
    {
      label: "table view",
      icon: "fa-solid fa-table",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("table view"),
    },
    {
      label: "Register shift",
      icon: "fa-solid fa-file-pen",
      className: "btn btn-info btn-sm",
      onClick: () => handleRegister(),
    },
  ].filter((action) => action.label !== viewType);

  return (
    <AppContainer
      title="Shift Templates"
      previousPageTitle="Dashboard"
      actions={filteredActions}
    >
      <div className="container-fluid">
        <Toaster />

        {/* Modals */}
        {Update}
        {register}

        {loading ? (
          <div className="text-center my-5 fs-5 text-muted">
            Loading shift templates...
          </div>
        ) : shifts.length === 0 ? (
          <div className="text-center my-5 fs-5 text-muted">
            No shift templates available
          </div>
        ) : viewType === "table view" ? (
          // TABLE VIEW
          <div className="row">
            <div className="col-12">
              <div className="card custom-card">
                <div className="card-body">
                  <h6 className="card-title mb-1">Shift Templates</h6>
                  <p className="text-muted card-sub-title">
                    List of registered shift templates
                  </p>

                  <div className="table-responsive">
                    <table className="table table-bordered text-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Shift Name</th>
                          <th>Start Time</th>
                          <th>End Time</th>
                          <th>Status</th>
                          <th>Created At</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {shifts.map((shift, index) => (
                          <tr key={shift.id}>
                            <td>{index + 1}</td>
                            <td>{shift.shift_name}</td>
                            <td>{shift.start_time}</td>
                            <td>{shift.end_time}</td>
                            <td>
                              <span
                                className={`badge ${
                                  shift.status === "1"
                                    ? "bg-success"
                                    : "bg-danger"
                                }`}
                              >
                                {shift.status === "1" ? "Active" : "Inactive"}
                              </span>
                            </td>
                            <td>{shift.created_at}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-info"
                                onClick={() => handleUpdate(shift)}
                              >
                                <i className="fe fe-edit-2" /> Edit
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          // CARD VIEW
          <div className="row">
            {shifts.map((shift) => (
              <div className="col-md-4 col-lg-3 mb-3" key={shift.id}>
                <div
                  className="card h-100"
                  style={{
                    borderRadius: "12px",
                    boxShadow: "4px 4px 12px rgba(0,0,0,0.1)",
                  }}
                >
                  <div className="card-body text-center">
                    <h6 className="mb-1">{shift.shift_name}</h6>
                    <small className="d-block text-muted">
                      {shift.start_time} → {shift.end_time}
                    </small>

                    <div className="mt-2">
                      <span
                        className={`badge px-3 py-1 ${
                          shift.status === "1" ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {shift.status === "1" ? "Active" : "Inactive"}
                      </span>
                    </div>

                    <small className="d-block text-muted mt-2">
                      Created: {shift.created_at}
                    </small>
                  </div>

                  <div className="d-flex justify-content-center mt-1 mb-2">
                    <button
                      className="btn btn-sm btn-outline-primary px-3"
                      onClick={() => handleUpdate(shift)}
                    >
                      <i className="fe fe-edit-2"></i>
                      Edit
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AppContainer>
  );
};

export default ViewShiftTemplates;
